import React from 'react';

const Sponsor = () => {
    return (
        <>
            <div className='px-4 py-6 mx-auto sm:max-w-xl md:max-w-full md:px-24 lg:px-8'>
                <div>
                    <h6 className='text-md font-semibold text-gray-800 dark:text-white lg:text-md text-left'>AUSPICIADORES:</h6>
                </div>
                <div className='dark:bg-gray-900'>
                    <div className='container px-6 py-16 mx-auto text-left -mt-12'>
                        <div className=' mx-auto'>
                            <div className='grid grid-cols-2 gap-8 md:grid-cols-2 lg:grid-cols-5'>
                                <div className='flex items-center justify-center col-span-1 md:col-span-1 lg:col-span-1  mt-6 scale-110 mr-8'>
                                    <img src='/assets/auspiciadores/1.png' alt='logo rancagua'/>
                                </div>

                                <div className='flex items-center justify-center col-span-1 md:col-span-1 lg:col-span-1 '>
                                    <img src='/assets/auspiciadores/2.png' alt='GORE'/>
                                </div>

                                <div className='flex items-center justify-center col-span-1 md:col-span-1 lg:col-span-1 scale-75 -mr-10'>
                                    <img src='/assets/auspiciadores/3.png' alt='UOH Logo'/>
                                </div>

                                <div className='flex items-center justify-center col-span-1 md:col-span-2 lg:col-span-2 scale-75 '>
                                    <img src='/assets/auspiciadores/4.png' alt='banner Gobierno Abierto'/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Sponsor;